<template>
  <aside class="topic-sidebar">
    <button
      type="button"
      class="topic-nav-item"
      :class="{ 'is-active': feedMode === 'latest' && !topicId }"
      @click="$emit('select', { mode: 'latest', topicId: null })"
    >
      最新
    </button>
    <button
      type="button"
      class="topic-nav-item"
      :class="{ 'is-active': feedMode === 'hot' && !topicId }"
      @click="$emit('select', { mode: 'hot', topicId: null })"
    >
      热门
    </button>

    <div class="topic-section-title">话题</div>
    <button
      v-for="topic in topics"
      :key="topic.id"
      type="button"
      class="topic-nav-item"
      :class="{ 'is-active': Number(topicId) === Number(topic.id) }"
      @click="$emit('select', { mode: 'latest', topicId: topic.id })"
    >
      {{ topic.name }}
    </button>
  </aside>
</template>

<script>
export default {
  name: "TopicSidebar",
  props: {
    topics: { type: Array, default: () => [] },
    feedMode: { type: String, default: "latest" },
    topicId: { type: [Number, String], default: null },
  },
  emits: ["select"],
};
</script>

<style scoped>
.topic-sidebar {
  background: var(--el-bg-color);
  border-radius: 4px;
  padding: 12px 8px;
}

.topic-section-title {
  margin: 12px 12px 6px;
  font-size: 12px;
  color: var(--el-text-color-secondary);
}

.topic-nav-item {
  display: block;
  width: 100%;
  text-align: left;
  border: none;
  background: transparent;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 14px;
  color: var(--el-text-color-primary);
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.topic-nav-item:hover {
  background: var(--el-fill-color-light);
}

.topic-nav-item.is-active {
  color: var(--el-color-primary);
  font-weight: 600;
  background: var(--el-color-primary-light-9);
}
</style>
